import * as React from 'react'
import { Layout, Menu, theme, Button } from 'antd'
import type { MenuProps } from 'antd'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ApiOutlined, LogoutOutlined } from '@ant-design/icons'

const { Header, Sider, Content } = Layout
const CONSOLE_TAB_SESSION_KEY = 'console.tab_session_authorized'

type MenuItem = Required<MenuProps>['items'][number]

const TOP_MENU_ITEMS: MenuItem[] = [
  {
    key: 'ret00cs',
    icon: <ApiOutlined />,
    label: '接口管理',
  },
]

interface Props {
  sidebar: JSX.Element
  moduleKey?: string
  rightExtra?: JSX.Element
}

export default function AppLayout({ sidebar, moduleKey = 'ret00cs', rightExtra }: Props): JSX.Element {
  const navigate = useNavigate()
  const location = useLocation()
  const {
    token: { colorBgContainer },
  } = theme.useToken()

  const topSelectedKey = React.useMemo(() => {
    const hash = location.hash.replace(/^#/, '')
    if (hash.includes('ret00cs') || location.pathname.includes('ret00cs')) return 'ret00cs'
    return moduleKey
  }, [location, moduleKey])

  const handleTopMenuClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'ret00cs') {
      navigate('/ret00cs')
    }
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        className="console-app-header"
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '0 24px',
          background: '#FA8C16',
          height: 56,
          lineHeight: '56px',
          borderBottom: 'none',
        }}
      >
        <div style={{ color: '#fff', fontSize: 18, fontWeight: 600, marginRight: 48, whiteSpace: 'nowrap', height: 56, lineHeight: '56px', display: 'flex', alignItems: 'center' }}>
          ACC管理平台
        </div>
        <Menu
          mode="horizontal"
          selectedKeys={[topSelectedKey]}
          items={TOP_MENU_ITEMS}
          onClick={handleTopMenuClick}
          style={{
            flex: 1,
            minWidth: 0,
            background: 'transparent',
            borderBottom: 'none',
            lineHeight: '56px',
            height: 56,
          }}
          className="console-top-menu"
        />
        <style>{`
          .console-top-menu .ant-menu-title-content,
          .console-top-menu .ant-menu-item,
          .console-top-menu .ant-menu-submenu-title {
            color: #fff !important;
          }
          .console-top-menu .ant-menu-item .anticon,
          .console-top-menu .ant-menu-submenu-title .anticon {
            color: #fff !important;
          }
          .console-top-menu .ant-menu-item {
            background: transparent !important;
            margin-top: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 0 !important;
          }
          .console-top-menu .ant-menu-item .ant-menu-title-content {
            display: inline-flex;
            align-items: center;
            line-height: 1.2;
          }
          .console-top-menu .ant-menu-item:hover {
            background: rgba(255,255,255,0.12) !important;
            color: #fff !important;
          }
          .console-top-menu .ant-menu-item:active {
            background: rgba(255,255,255,0.2) !important;
            color: #fff !important;
          }
          .console-top-menu .ant-menu-item-selected {
            background: transparent !important;
            color: #fff !important;
          }
          .console-top-menu .ant-menu-item-selected::after {
            border-bottom: 2px solid #fff !important;
            bottom: 6px !important;
          }
          .console-top-menu .ant-menu-vertical .ant-menu-item-selected,
          .console-top-menu .ant-menu-horizontal .ant-menu-item-selected {
            background: transparent !important;
          }
          .ant-layout-header.console-app-header {
            height: 56px !important;
            line-height: 56px !important;
            padding: 0 24px;
            display: flex;
            align-items: center;
          }
          .ant-layout-header.console-app-header .ant-menu {
            line-height: 56px;
            height: 56px;
            display: flex;
            align-items: center;
          }
          .ant-layout-header.console-app-header .ant-menu-item,
          .ant-layout-header.console-app-header .ant-menu-submenu-title {
            height: 56px !important;
            line-height: 56px !important;
            padding-inline: 16px !important;
            margin-inline: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
          }
          .ant-layout-header.console-app-header .ant-menu-submenu-title {
            display: inline-flex !important;
            align-items: center !important;
          }
        `}</style>
        {rightExtra || null}
        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={() => {
            try {
              window.sessionStorage.removeItem(CONSOLE_TAB_SESSION_KEY)
            } catch (error) {
              // Ignore storage failures and fall through to server logout.
            }
            window.location.href = '/init/login_out'
          }}
          style={{
            color: '#fff',
            marginLeft: rightExtra ? 8 : 16,
            fontSize: 14,
            height: 56,
            borderRadius: 0,
            padding: '0 16px',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          退出登录
        </Button>
      </Header>
      <Layout>
        <Sider
          width={260}
          style={{ background: colorBgContainer, borderRight: '1px solid #f0f0f0', overflow: 'auto' }}
          breakpoint="lg"
          trigger={null}
        >
          {sidebar}
        </Sider>
        <Content
          style={{
            margin: 16,
            padding: 0,
            paddingLeft: 24,
            paddingRight: 24,
            paddingBottom: 24,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: 0,
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}
